import { usePathname, useRouter } from "next/navigation"
import { createSearchPagePathname } from "@/services/pathname"

export function useHandleSearchFromSearchBar(search: Record<string, string>, mode: string, type: string, target: string) {
    const pathname = usePathname()
    const { replace, push } = useRouter()

    function handleSearch() {
        const params = new URLSearchParams()
        Object.entries(search).map(([filterName, filterValue]) => {
            params.set(filterName, Array.isArray(filterValue) ? filterValue.join(',') : filterValue)
        })
        if (mode === 'home') {
            push(
                createSearchPagePathname(type, target, search)
            )
        }
        if (mode === 'search') {
            replace(`${pathname}?${params.toString()}`, {
                scroll: false
            })
        }
        
    }

    return handleSearch
}